/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Kickstart
 * @author     Sascha Dörrenbach <sascha.doerrenbach@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */
var Dotfly = {

    /**
     * init/constructor method
     */
    init: function() {
        this.instant();
        this.domReady();
        this.onLoad();
        this.onResize();
        this.onScroll();
        this.onOrientationchange();
    },

    /**
     * Binding for events at interpreting
     */
    instant: function() {
        //Stuff
    },

    /**
     * Binding for domReady-Event
     */
    domReady: function() {
        var that = this;
        $(document).ready(function() {
            setTimeout(function() {
                $('html').removeClass('no-transition');
            }, 200);
            that.initSlider();
            that.addJsClass();
            that.addTouchClass();
            that.startDraggingOnTouch();
            that.transitionResizeHandling();
            that.openLightbox();
            that.closeLightbox();
            that.triggerCssAnimation();
            that.openFlyout();
            //that.openSearch();
            that.navigationOnHover();
            that.heroSlider();
            that.brandsSlider();
            that.brandsLightboxSlider();
            that.newsSlider();
            that.articleSlider();
            that.backToTop();
            that.accordion();
            that.focusHandling();
            if($('input[type="file"]').length) {
                that.setUploadValue();
            }
            that.changeImage();
            that.toggleNav();
            that.appendNavElements();
            that.openNextLevel();
            that.matchHeight();
            that.reduceHeader();
            if(!$('.contacts').length) {
                that.tabbing();
            }
            that.system();
            that.closeLayer();
            that.onOrganisationUnitChange();
            that.openPostelCodeSuggest();
            that.onPostalCodeChange();
            that.filterPostalCode();
            that.filterOrganisation();
            that.initResponsiveBreadcrumb();
            that.formValidate();
            that.autoPlayThemeWorldVideo();
            that.autoPlayVideo();
            that.makeRowGrey();
            that.enableLightSlider();
            that.detectRatio();
            that.hero();
            that.topNavi();
            that.TeaserSlide();
            that.initObjectfitFallback();
            if ($('.js-map').length) {
                that.showMap();
            };
        });
    },


    /**
     * Topnavi Flyout
     */
    topNavi: function() {

        var trigger = $('.c-topnavi__trigger');
        var flyout = $('.c-topnavi__sublist');

        trigger.on('mouseover', function(){
            $(this).children(flyout).addClass('is--open');
        });

        trigger.on('mouseout', function(){
            $(this).children(flyout).removeClass('is--open');
        });

        trigger.on('click', function(){
            $(this).children(flyout).toggleClass('is--open');
        });
    },


    initObjectfitFallback: function() {
        /*eslint-disable no-undef */
        if('objectFit' in document.documentElement.style === false) {
            $('body').addClass('no--object-fit');
            $('.js-image-wrap').each(function () {
                var wrapper = $(this),
                    url = wrapper.find('img').prop('src');
                if (url) {
                    wrapper.css('backgroundImage', 'url(' + url + ')').addClass('is--fixed').find('.js-picture').hide();
                }
            });
        }
        /*eslint-enable no-unused-vars*/
    },


    /**
     * Master Slider
     */
    initSlider : function() {
    var _sliders = $('.js-slick');

    _sliders.each(function(){
        var _slider = $(this);
        var _wrap = _slider.find('.c-slider__wrap');

        _wrap.on('init', function(){
            _slider.find('.slick-prev').html('1 /');
            _slider.find('.slick-next').html('&nbsp;' + _slider.find('.slick-slide:not(.slick-cloned)').length);
        });

        _wrap.slick({
            dots: !_slider.is('.is--b'),
            slidesToShow: 1,
            appendArrows: _slider.find('.c-slider__arrows'),
            appendDots: _slider.find('.c-slider__dots'),
            cssEase: 'cubic-bezier(0.785, 0.135, 0.150, 0.860)',
            speed: 800,
            autoplay : true,
            autoplaySpeed : 5000,
            adaptiveHeight: true
        })
            .on('afterChange', function(){
                _slider.find('.slick-prev').html((_wrap.slick('slickCurrentSlide') + 1) + ' /');
                _slider.find('.slick-next').html('&nbsp;' + _wrap.find('.slick-slide:not(.slick-cloned)').length);
            });
    });
    },

    TeaserSlide: function() {
        $('.c-teaserrow__wrapper').slick({
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },

    /**
     * Binding for onLoad-Event
     */
    onLoad: function() {
        $(window).load(function() {
            //Stuff
        });
    },

    /**
     * Binding for onResize-Event
     */
    onScroll: function() {
        $(window).on('scroll touchmove', function() {
            Dotfly.reduceHeader();
        });
    },

    /**
     * Binding for onResize-Event
     */
    onResize: function() {
        var iWidth = $(window).width();
        $(window).on('resize', function() {
            if($(window).width() != iWidth) {
                Dotfly.appendNavElements();
                Dotfly.removeClasses();
                iWidth = $(window).width();
            }
        });
    },

    /**
     * Binding for onOrientationchange-Event
     */
    onOrientationchange: function() {
        $(window).on('orientationchange', function() {
            Dotfly.appendNavElements();
            Dotfly.removeClasses();
        });
    },

    /**
     * add js class
     */
    addJsClass: function() {
        $('html').addClass('js');

        /** check flexbox **/
        var doc   = document.body || document.documentElement;
        var style = doc.style;
        if(style.webkitFlexWrap == '' ||
            style.msFlexWrap == '' ||
            style.flexWrap == '') {
            doc.className += " is--flex";
        } else {
            doc.className += " no--flex";
        }
        var userAgent = navigator.userAgent;

        if(userAgent.indexOf('Trident/7.0') != -1) {
            doc.className += " ie11";
        }
        if(userAgent.indexOf("MSIE 10.0") != -1) {
            doc.className += " ie10";
        }
        if(userAgent.indexOf('MSIE ') != -1) {
            doc.className += " ie";
        }
        if(userAgent.indexOf('Edge') != -1) {
            doc.className += " edge";
        }
    },

    /**
     * add touch class
     */
    addTouchClass: function() {
        function is_touch_device() {
            return !!('ontouchstart' in window);
        }

        if(is_touch_device()) {
            $('html').addClass('touch');
        } else {
            $('html').addClass('no-touch');
        }
    },

    /**
     * check if dragging(touching) is triggered
     */
    startDraggingOnTouch: function() {
        var _oDragging = false;
        $('body').on('touchmove', function() {
            _oDragging = true;
        });
    },

    /**
     * transition resize handling
     */
    transitionResizeHandling: function() {
        var _oResizeId;
        var _oHtml = $('html');
        $(window).resize(function() {
            clearTimeout(_oResizeId);
            _oHtml.addClass('no-transition');
            _oResizeId = setTimeout(doneResizing, 500);
        });

        function doneResizing() {
            _oHtml.removeClass('no-transition');
        }
    },

    /**
     * set upload value
     */
    setUploadValue: function() {

        var setName = function(btn, file) {
            var fileName = $(btn)[0].files[0];
            if(fileName) {
                $(file).val(fileName.name);
            }
        };

        var addDeleteButton = function(button) {
            var item = $(button).parents('.u-flex__item');

            if(item.first().find('.js-deleteFile').length === 0)
                item.first().prepend($('<div class="btn btn__delete js-deleteFile"></div>'));

            var btn = $('.js-deleteFile');
            btn.on('click', function() {
                var file = $(this).next('.field__file');
                file.val(null);
                $(this).remove();
            });
        };
        //Ich musste die Funktionen auf jQuery umbauen, da natives Javascript kein Event-Binding auf
        //dynamisch generierte Elemente ermöglicht.
        $('body').on('change', '#uploadBtn1', function() {
            setName('#uploadBtn1', '#uploadFile1');
            addDeleteButton('#uploadBtn1');
        });

        $('body').on('change', '#uploadBtn2', function() {
            setName('#uploadBtn2', '#uploadFile2');
            addDeleteButton('#uploadBtn2');
        });

        $('body').on('change', '#uploadBtn3', function() {
            setName('#uploadBtn3', '#uploadFile3');
            addDeleteButton('#uploadBtn3');
        });

        $('body').on('change', '#uploadBtn4', function() {
            setName('#uploadBtn4', '#uploadFile4');
            addDeleteButton('#uploadBtn4');
        });
    },

    /**
     * open lightbox
     */
    openLightbox: function() {
        var _oButton = $('.system__opener');

        _oButton.on('click', function() {
            $(this).parent('.system__inner').addClass('system__inner--active');
            $('body').addClass('blur-in');

            return false;
        });
    },

    /**
     * close lightbox
     */
    closeLightbox: function() {
        var _oButton = $('.system__closer');

        _oButton.on('click', function() {
            $(this).parents('.system__inner').removeClass('system__inner--active');
            $('body').removeClass('blur-in').addClass('blur-out');
            setTimeout(function() {
                $('body').removeClass('blur-out');
            }, 1000);

            return false;
        });
    },

    /**
     * trigger css animation on scroll
     *
     * @return void
     */
    triggerCssAnimation: function() {
        var _oWindow          = $(window),
            _iWinHeightPadded = _oWindow.height() * 1.1;

        _oWindow.on('scroll resize', revealOnScroll);

        function revealOnScroll() {
            var _iScrolled        = _oWindow.scrollTop(),
                _iWinHeightPadded = _oWindow.height() * 1.1;

            // Showed...
            $(".animation:not(.animated)").each(function() {
                var $this     = $(this),
                    offsetTop = $this.offset().top;

                if(_iScrolled + _iWinHeightPadded > offsetTop) {
                    if($this.data('timeout')) {
                        window.setTimeout(function() {
                            $this.addClass('animated ' + $this.data('animation'));
                        }, parseInt($this.data('timeout'), 10));
                    } else {
                        $this.addClass('animated ' + $this.data('animation'));
                    }
                }
            });
        }

        revealOnScroll();
    },

    /**
     * open flyout
     */
    openFlyout: function() {
        var _oButton = $('.flyout__trigger');

        _oButton.on('click', function() {
            $('.flyout__item').removeClass('flyout__item--open');
            $(this).nextAll('.flyout__item').addClass('flyout__item--open');
            return false;
        });

        $(document).click(function(e) {
            if($(e.target).parents('li').hasClass('flyout')) {
            } else {
                $('.flyout__item').removeClass('flyout__item--open');
            }
        });

        $(document).keydown(function(e) {
            if(e.which == 27) {
                $('.flyout__item').removeClass('flyout__item--open');
            }
        });

    },

    /**
     * open search
     */
    openSearch: function() {
        var _oButton = $('.search__trigger');

        _oButton.on('click', function() {
            $(this).parent('.search').toggleClass('search--open');
            setTimeout(function() {
                $('#searchParam').focus();
            }, 600);

            return false;
        });

        $(document).click(function(e) {
            if($(e.target).parents('.search').hasClass('search--open')) {
            } else {
                $('header .search').removeClass('search--open');
            }
        });
    },

    /**
     * navigation handle on hover
     */
    navigationOnHover: function() {
        var _oNavItem = $('.navigation__level--0 > li');

        _oNavItem.hover(function() {
            if($(this).find('.navigation__flyout').length) {
                $(this).find('.navigation__flyout').stop(true, true).delay(50).addClass('navigation__flyout--open');
                $('.main').addClass('main--hide');
            }
        }, function() {
            $('.navigation__flyout').stop(true, true).delay(50).removeClass('navigation__flyout--open');
            $(this).removeClass('level__hover');
            $('.main').removeClass('main--hide');
        });
    },

    /**
     * Init Hero-Slider
     */
    heroSlider: function() {
        var arrows  = $('.theme__slider-nav');
        var sliders = $(".theme__slider-hero");

        $(".theme__slider").each(function() {
            var self = $(this);

            var slick = self.find(sliders).slick({
                appendArrows: self.find(arrows),
                dots: true,
                dotsClass: 'theme__slider-control',
                infinite: true,
                fade: true,
                speed: 1400,
                autoplay: true,
                autoplaySpeed: 2500,
                adaptiveHeight: true,
                lazyLoad: 'ondemand',
                prevArrow: '<button type="button" data-role="none" class="theme__slider-nav--prev" aria-label="Previous" tabindex="0" role="button"></button>',
                nextArrow: '<button type="button" data-role="none" class="theme__slider-nav--next" aria-label="Next" tabindex="0" role="button"></button>'
            });
        });
    },

    /**
     * Init Hero-Slider
     */
    hero: function() {
        var h1  = $('.hero__text h1');
        var h2  = $('.hero__text h2');
        var duration = 7000;
        window.setTimeout(animateHeadlines, duration);

        function animateHeadlines() {
            h1.toggleClass("is--animated");
            h2.toggleClass("is--animated");
            window.setTimeout(animateHeadlines, duration);
        }
    },

    /**
     * Init Brands-Slider
     */
    brandsSlider: function() {
        $('.theme__brands-slider').slick({
            infinite: true,
            useTransform: true,
            speed: 1400,
            slidesToShow: 5,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            prevArrow: '<button type="button" data-role="none" class="theme__brands-nav--prev" aria-label="Previous" tabindex="0" role="button"></button>',
            nextArrow: '<button type="button" data-role="none" class="theme__brands-nav--next" aria-label="Next" tabindex="0" role="button"></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    },

    /**
     * Init Brands-Lightbox-Slider
     */
    brandsLightboxSlider: function() {
        $('.theme__lightbox-slider').slick({
            infinite: true,
            useTransform: true,
            speed: 1400,
            slidesToShow: 5,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            prevArrow: '<button type="button" data-role="none" class="theme__brands-nav--prev" aria-label="Previous" tabindex="0" role="button"></button>',
            nextArrow: '<button type="button" data-role="none" class="theme__brands-nav--next" aria-label="Next" tabindex="0" role="button"></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.theme__lightbox-slides').slickLightbox();
    },

    /**
     * Init News-Slider
     */
    newsSlider: function() {
        $('.theme__news-slider').slick({
            arrows: false,
            infinite: false,
            dots: true,
            dotsClass: 'theme__news-control',
            useTransform: true,
            speed: 1400,
            slidesToShow: 2,
            slidesToScroll: 2,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },

    /**
     * Init Article-Slider
     */
    articleSlider: function() {
        $('.news__slides').slick({
            arrows: false,
            infinite: false,
            dots: true,
            dotsClass: 'news__control',
            useTransform: true,
            speed: 1400,
            slidesToShow: 2,
            slidesToScroll: 2,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    },

    /**
     * Backtotop
     */
    backToTop: function() {
        var backToTop = $('#backtotop');

        // Hide when the user is at the top
        var backScroll = this.debounce(function() {
            if($(window).scrollTop() > 200) {
                backToTop.removeClass('backtotop--hidden');
            } else {
                backToTop.addClass('backtotop--hidden');
            }
        }, 50, false);

        backScroll();
        $(window).on('scroll', backScroll);

        // Click Event
        backToTop.on('click', function() {
            $('html, body').stop().animate({
                scrollTop: 0
            }, 500);

            $(this).addClass('backtotop--hidden');
        });
    },

    /**
     * input focus handling
     *
     * @return void
     */
    focusHandling: function() {

        var _oInput = $('form .field__input');

        _oInput.each(function() {
            if($(this).val().trim() !== '') {
                $(this).parent('span').addClass('input--filled');
            }
        });

        _oInput.focus(function() {
            $(this).parent('span').addClass('input--filled');
        });

        _oInput.blur(function(e) {
            if(e.target.value.trim() === '') {
                $(this).parent('span').removeClass('input--filled');
            }
        });
    },

    /**
     * change image on hover
     *
     * @return void
     */
    changeImage: function() {
        var _oLinkLevel0 = $('.navigation__level--0 > li > a');
        var _oLinkLevel1 = $('.navigation__level--1 > li > a');
        var _oLinkLevel2 = $('.navigation__level--2 > li > a');
        var _oImageBox   = $('.navigation__picture img');

        _oLinkLevel0.on('mouseenter', function() {
            var _oSelf = $(this);
            var _sData = _oSelf.attr('data-image');
            _oImageBox.attr('src', _sData);
        });

        _oLinkLevel1.on('mouseenter', function() {
            var _oSelf = $(this);
            var _sData = _oSelf.attr('data-image');
            if(_sData != _oImageBox.attr('src')) {
                _oImageBox.hide();
                _oImageBox.attr('src', _sData).show();
            }
        });

        _oLinkLevel2.on('mouseenter', function() {
            var _oSelf = $(this);
            var _sData = _oSelf.parent('li').parents('li').find('a').attr('data-image');
            if(_sData != _oImageBox.attr('src')) {
                _oImageBox.hide();
                _oImageBox.attr('src', _sData).show();
            }
        });
    },

    /**
     * toggle mobile navigation
     *
     * @return void
     */
    toggleNav: function() {
        $('#ToggleNav').click(function() {
            $(this).toggleClass('open');
            $('body').toggleClass('push');
        });
    },

    /**
     * append meta and main navigation in side wrap
     *
     * @return void
     */
    appendNavElements: function() {
        var _oMobileNavigation = $('#MobileNav .mobile-nav__wrap');
        var _oMainNavigation   = $('#Navigation');
        var _oMetaNavigation   = $('#Meta');
        var _oMainNavWrapper   = $('.navigation');
        var _oMetaNavWrapper   = $('.meta');

        if($(window).innerWidth() <= 1024) {
            _oMainNavigation.appendTo(_oMobileNavigation);
            _oMetaNavigation.appendTo(_oMobileNavigation);
        } else {
            _oMainNavigation.appendTo(_oMainNavWrapper);
            _oMetaNavigation.appendTo(_oMetaNavWrapper);
        }
    },

    /**
     * open next navigation level
     *
     * @return void
     */
    openNextLevel: function() {
        var _oFlap = $('.flap');

        _oFlap.on('click', function() {
            var _oSelf = $(this);

            if(_oSelf.hasClass('flap--open')) {
                _oSelf.removeClass('flap--open');
                _oSelf.next('div').slideUp('fast');
            } else {
                _oSelf.addClass('flap--open');
                _oSelf.next('div').slideDown('400');
            }
        });
    },

    /**
     * remove all mobile nav classes
     *
     * @return void
     */
    removeClasses: function() {
        $('.flap').removeClass('flap--open');
        $('body').removeClass('push');
        $('#ToggleNav').removeClass('open');
    },

    /**
     * match height of quote boxes
     *
     * @return void
     */
    matchHeight: function() {
        equalheight = function(container) {

            var _iCurrentTallest  = 0,
                _iCurrentRowStart = 0,
                _iRowDivs         = new Array(),
                $_oEl,
                _oTopPosition     = 0;

            $(container).each(function() {

                $_oEl = $(this);
                $($_oEl).height('auto');
                _oTopPosition = $_oEl.position().top;

                if(_iCurrentRowStart != _oTopPosition) {
                    for(currentDiv = 0; currentDiv < _iRowDivs.length; currentDiv++) {
                        _iRowDivs[currentDiv].height(_iCurrentTallest);
                    }
                    _iRowDivs.length  = 0; // empty the array
                    _iCurrentRowStart = _oTopPosition;
                    _iCurrentTallest  = $_oEl.height();
                    _iRowDivs.push($_oEl);
                } else {
                    _iRowDivs.push($_oEl);
                    _iCurrentTallest = (_iCurrentTallest < $_oEl.height()) ? ($_oEl.height()) : (_iCurrentTallest);
                }
                for(currentDiv = 0; currentDiv < _iRowDivs.length; currentDiv++) {
                    _iRowDivs[currentDiv].height(_iCurrentTallest);
                }
            });
        };

        $(window).load(function() {
            equalheight('.theme__contact-data');
        });

        $(window).resize(function() {
            equalheight('.theme__contact-data');
        });

        $(window).on('orientationchange', function() {
            equalheight('.theme__contact-data');
        });
    },

    /**
     * reduce header on scroll
     *
     * @return void
     */
    reduceHeader: function() {
        var _iScroll = $(window).scrollTop();
        var _oHeader = $('.header');

        if(_iScroll >= 150) {
            _oHeader.addClass('header--reduce');
        } else {
            _oHeader.removeClass('header--reduce');
        }
    },

    /**
     * tabbing
     *
     * @return void
     */
    tabbing: function() {
        var _oTabs = $('.theme__tabs');

        _oTabs.each(function(index) {
            $(this).addClass('Tabs-' + index);
        });

        $('.Tabs-0, .Tabs-1, .Tabs-2, .Tabs-3, .Tabs-4, .Tabs-5, .Tabs-6, .Tabs-7, .Tabs-8, .Tabs-9, .Tabs-10, .Tabs-11, .Tabs-12, .Tabs-13, .Tabs-14').tabs({
            show: 'fade', hide: 'fade'
        });
    },

    /**
     * Loads contact map, filtered by postalcode and organisation unit
     */
    onOrganisationUnitChange: function() {
        var _oListItem = $('.field__company .suggest__link');

        _oListItem.on('click', function(e) {
            e.preventDefault();

            var _oSelf       = $(this);
            var _sCode       = _oSelf.data('code');
            var _sId         = _oSelf.data('id');
            var _oSelected   = _oSelf.data('isexternal');
            var _oField      = $('#organizationUnit');
            var $contactList = $('#contactList');

            _oField.val(_sCode);

            if(_oSelected == 1) {
                $('.field__zip').show();
            } else {
                $('.field__zip').hide();
            }

            if(_oSelected != 1) {
                $.ajax({
                    url: '?' + _sId,
                    data: {
                        cl: "contactoverview",
                        fnc: "getFilteredContacts",
                        renderPartial: "1",
                        unitId: _sId
                    },
                    success: function(result) {
                        $contactList.html(result.content);

                        $("html, body").animate({
                            scrollTop: $contactList.offset().top
                        }, 600);

                        _oField.removeClass('form--active');
                    }
                });
            } else {
                _oField.removeClass('form--active');
            }
        });
    },

    /**
     * open postelcode suggest
     */
    openPostelCodeSuggest: function() {
        var _oTrigger = $('.field__input');

        if($('.contacts').length) {
            _oTrigger.on('click', function() {
                $(this).addClass('form--active');
            });

            $('html').click(function(event) {
                if($(event.target).closest('.field__suggest').length === 0) {
                    _oTrigger.removeClass('form--active');
                    $('.suggest__link').removeClass('data--hide');
                }
            });
        }
    },

    /**
     * Loads contact map, filtered by postalcode and organisation unit
     */
    onPostalCodeChange: function() {
        var _oListItem = $('.field__zip .suggest__link');

        _oListItem.on('click', function(e) {
            e.preventDefault();

            var _oSelf       = $(this);
            var _sCode       = _oSelf.data('code');
            var _sId         = _oSelf.data('id');
            var _oField      = $('#Zip');
            var $contactList = $('#contactList');

            _oField.val(_sCode);

            $.ajax({
                type: 'get',
                url: '?' + _sId,
                data: {
                    cl: "contactoverview",
                    fnc: "getFilteredContacts",
                    renderPartial: "1",
                    postalcodeId: _sId
                },
                success: function(result) {
                    $contactList.html(result.content);

                    $("html, body").animate({
                        scrollTop: $contactList.offset().top
                    }, 600);

                    _oField.removeClass('form--active');
                }
            });
        });
    },

    /**
     * filter postalcode
     */
    filterPostalCode: function() {
        var _oField       = $('#Zip');
        var _oSuggest     = $('.field__zip .suggest ul li');
        var _oSuggestItem = $('.field__zip .suggest__link');

        _oField.on('keyup', function() {
            _oSuggestItem.removeClass('data--show');

            if($(this).val().length) {
                _oSuggestItem.addClass('data--hide');
            } else {
                _oSuggestItem.removeClass('data--hide');
            }

            if(_oField.val() > 1) {
                _oSuggestItem.removeClass('data--show');
                _oSuggest.each(function() {
                    var _oSelf = $(this);
                    var _oItem = _oSelf.find('a');
                    var _oCode = _oItem.attr('data-code');

                    if(_oField.val().substring(0, 1) == _oCode.substring(0, 1) && _oField.val().substring(0, 2) == _oCode.substring(0, 2)) {
                        _oItem.addClass('data--show');
                    }
                });
            } else {
                _oSuggest.each(function() {
                    var _oSelf = $(this);
                    var _oItem = _oSelf.find('a');
                    var _oCode = _oItem.attr('data-code');

                    if(_oField.val().substring(0, 1) == _oCode.substring(0, 1)) {
                        _oItem.addClass('data--show');
                    }
                });
            }
        });
    },

    /**
     * filter organisation
     */
    filterOrganisation: function() {
        var _oField       = $('#organizationUnit');
        var _oSuggest     = $('.field__company .suggest ul li');
        var _oSuggestItem = $('.field__company .suggest__link');

        _oField.on('keyup', function() {
            _oSuggestItem.removeClass('data--show');

            if($(this).val().length) {
                _oSuggestItem.addClass('data--hide');
            } else {
                _oSuggestItem.removeClass('data--hide');
            }

            _oSuggestItem.removeClass('data--show');
            _oSuggest.each(function() {
                var _oSelf  = $(this);
                var _oItem  = _oSelf.find('a');
                var _oCode  = _oItem.attr('data-code').toLowerCase();
                var _sValue = _oField.val().toLowerCase();

                if(_sValue.toLowerCase().indexOf(_oCode) >= 0 || _oCode.toLowerCase().indexOf(_sValue) >= 0) {
                    _oItem.addClass('data--show');
                }
            });
        });
    },

    /**
     * check if system
     *
     * @return void
     */
    system: function() {
        var _oTheme = $('.theme');

        if(_oTheme.find('.system').length) {
            _oTheme.addClass('theme--overflow');
        }
    },

    /**
     * close layer on document click
     *
     * @return void
     */
    closeLayer: function() {
        $(document).click(function(e) {
            if($(e.target).hasClass('system__lightbox')) {
                $('.system__inner').removeClass('system__inner--active');
            }
        });
    },

    /**
     * init responsive breadcrumb
     *
     * @return void
     */
    initResponsiveBreadcrumb: function() {
        if($('#Breadcrumbs').length) {
            $("#Breadcrumbs").rcrumbs({
                nbFixedCrumbs: 1,
                animation: {
                    activated: true, speed: 100
                }
            });
        }
    },

    /**
     * validate fallback
     *
     * @return void
     */
    formValidate: function() {
        $('form').submit(function(e) {

            var _oField = $(this).find('[required]');

            $(_oField).each(function() {
                if($(this).val() == '') {

                    $(this).focus();

                    e.preventDefault();
                    return false;
                }
            });
            return true;
        });
    },

    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     *
     * See: http://davidwalsh.name/javascript-debounce-function
     *
     * @param {Function} func - The callback function
     * @param {number} wait - Time to wait in ms
     * @param {boolean} immediate - Execute the callback immediately
     * @returns {Function}
     */
    debounce: function(func, wait, immediate) {
        var timeout;
        return function() {
            var _self = this;
            var args  = arguments;
            var later = function() {
                timeout = null;

                if(!immediate) {
                    func.apply(_self, args);
                }
            };

            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if(callNow) {
                func.apply(_self, args);
            }
        };
    },

    autoPlayThemeWorldVideo: function() {
        $('.theme__teaser-link').each(function() {
            var self = $(this);
            self.featherlight(self.data('featherlight'), {
                openSpeed: 100,
                afterContent: function() {
                    var $iframe = $('.featherlight-content .video__frame');
                    var url     = $iframe.prop('src');
                    if($iframe.hasClass('vimeo')) {
                        url += '&autoplay=true';
                        $iframe.prop('src', url);
                    } else {
                        url = url.replace("watch?v=", "embed/");
                        url += '&rel=0;autoplay=1';
                        $iframe.prop('src', url);
                    }
                }
            });
        });

        $('.js-videoContainer').each(function() {
            var $iframe = $('.hero__frame');
            var url     = $iframe.prop('src');

            var w = "embed/";
            var i1 = url.indexOf(w);
            var i2 = url.indexOf("?", i1+w.length);
            var ss = url.substr(i1+w.length, (i2 - (i1+w.length)));
            url = url + "?playlist="+ss;
            url = url.replace("&playlist=&", "&playlist="+ss+"&");
            $iframe.attr('src', url);
        });
    },

    autoPlayVideo: function() {
        $('.video-popup').each(function() {
            var self = $(this);
            self.featherlight(self.data('featherlight'), {
                openSpeed: 100,
                afterContent: function() {
                    var $iframe = $('.featherlight-content iframe');
                    var url     = $iframe.prop('src');
                    $iframe.prop('src', url)
                }
            });
        });
    },
    makeRowGrey: function() {
        $('.theme__text--full, .infobox').each(function() {
            var self = $(this);
            var row  = self.closest('.helper');
            row.addClass('full-grey');
        });
    },

    enableLightSlider: function() {
        var slider = $('.js-lightSlider').lightSlider({
            item: 1,
            pager: false,
            loop: true,
            mode: 'fade',
            controls: false,
            adaptiveHeight: true,
            onAfterSlide: function(el) {
                var e = el.find('.active');
                if(window.innerWidth <= 1024)
                    $('.elementSlider, .elementSlider__wrap').height(e.find('.elementSlider__img').height() + e.find('.elementSlider__content').height());
                else
                    $('.elementSlider, .elementSlider__wrap').height(e.find('.elementSlider__img').height());
            },
            onSliderLoad: function(el) {
                var e = el.find('.active');
                if(window.innerWidth <= 1024)
                    $('.elementSlider, .elementSlider__wrap').height(e.find('.elementSlider__img').height() + e.find('.elementSlider__content').height());
                else
                    $('.elementSlider, .elementSlider__wrap').height(e.find('.elementSlider__img').height());
            }
        });

        $('.js-nextSlide').on('click', function() {
            slider.goToNextSlide();
        });

        $('.js-prevSlide').on('click', function() {
            slider.goToPrevSlide();
        });

    },

    /**
     *
     */
    accordion: function() {
        var btn = $('.js-accordion');

        btn.on('click', function() {
            var parent      = $(this).parents('.accordion__item');
            var contentWrap = parent.find('.accordion__item-content');
            var content     = contentWrap.find('.accordion__item-content-inner');

            if(parent.hasClass('is--open')) {
                contentWrap.height(0);
                parent.removeClass('is--open');
            } else {
                if(content.html().trim().length !== 0) {
                    var height = parent.find('.accordion__item-content-inner').outerHeight();
                    contentWrap.height(height);
                    parent.addClass('is--open');
                }
            }

        });
    },

    detectRatio: function() {
        var hero   = $('.hero');
        var frame  = hero.find('iframe');
        var width  = hero.outerWidth(),
            height = hero.outerHeight();

        if(window.innerWidth <= 1024) {
            if(width > height) {
                frame.css("height", "50vh");
            }
            hero.height($('.js-videoContainer').height());
        }
    },

    showMap: function() {
        var $mapSRC = $('.js-map-placeholder').attr('data-map');

        $('.js-map-button').click(function() {
            $('.js-map-placeholder-iframe').attr('src', $mapSRC);
            $('.js-map-placeholder').fadeOut();
            $('.js-map-placeholder-iframe').fadeIn();
        });
    },
};

// Init
Dotfly.init();

